import Model from 'src/models/model'

export default class SassCompiler extends Model {
  static name = 'SassCompiler'

  static noId = true

  static define () {
    this.fields = {
      sass: {
        type: String,
        input: true
      },
      css: {
        type: String,
        output: true
      }
    }
  }

  async compile (sass) {
    this.sass = sass
    const { errors, results } = await this.save()

    if (errors?.length) {
      return {
        errors
      }
    }

    return {
      css: results?.css
    }
  }
}
